import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20portrait%20with%20soft%20natural%20light%2C%20minimalist%20neutral%20background%20with%20subtle%20cherry%20blossom%20petals%20falling%2C%20editorial%20fashion%20photography%2C%20warm%20ethereal%20atmosphere%2C%20high%20end%20beauty%20portrait%2C%20clean%20elegant%20composition&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
        alt="佐佐木希 - Nozomi Sasaki"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <p
          className="text-white/80 text-sm md:text-base tracking-widest mb-4"
          style={{ fontFamily: "var(--font-label)" }}
        >
          NOZOMI SASAKI OFFICIAL FAN SITE
        </p>
        <h1
          className="text-white text-3xl md:text-5xl lg:text-6xl font-bold mb-4"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          佐佐木希
        </h1>
        <p className="text-white/80 text-base md:text-lg max-w-xl mb-8 leading-relaxed">
          日本顶级女艺人、模特与演员，来自秋田县的国民女神
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/news"
            className="px-8 py-3 bg-white text-foreground-950 rounded-full text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap"
          >
            查看最新动态
          </Link>
          <Link
            to="/category/photo"
            className="px-8 py-3 border border-white/40 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            写真精选
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex justify-center">
          <div className="w-1 h-2 bg-white/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}